import styles from "./ProgramLevelMovements.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";

const data = [
  {
    _id: "1",
    programName: "Program 1",
    nextProgram: "Annual day",
    rule: "When reaching certain age",
    movementDate: "24/05/25",
  },
  {
    _id: "2",
    programName: "Program 1",
    nextProgram: "Annual day",
    rule: "When reaching certain age",
    movementDate: "24/05/25",
  },
  {
    _id: "3",
    programName: "Program 1",
    nextProgram: "Annual day",
    rule: "When reaching certain age",
    movementDate: "24/05/25",
  },
];

function ProgramLevelMovements() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);

      const cellStyle = { color: "var(--Grey_Color)" };

      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        programName: (
          <span style={{ color: "var(--Primary_Color)", fontWeight: 400 }}>
            {item.programName}
          </span>
        ),
        nextProgram: <span style={cellStyle}>{item.nextProgram}</span>,
        rule: <span style={cellStyle}>{item.rule}</span>,
        movementDate: <span style={cellStyle}>{item.movementDate}</span>,
      };
    });
  };
  
  const displayData = getColumnData(data);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: "checkBox",
    },
    { title: "Program Name", accessor: "programName" },
    { title: "Next Program", accessor: "nextProgram" },
    { title: "Movement Rule", accessor: "rule" },
    { title: "Movement Date", accessor: "movementDate" },
  ];

  return (
    <div className={styles.headerContainer}>
      <div className={styles.totalstudentcard}>
        <div className={styles.studentsection}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search Program"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.filters}>
            <Dropdown
              label="Next Program"
              options={["Annual day", "Graduation", "Summer Camp"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
          </div>
        </div>

        <div className={styles.dynamicdata}>
          <Dynamic
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>

        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default ProgramLevelMovements;
